module.exports = __webpack_public_path__ + "img/tunisia.aa720a3d.svg";